import * as React from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { ChangeEvent, useState, useCallback } from "react";
import { useStyles } from "../../features/Auth/Auth.styles";

interface RegisterInfo {
  username: string;
  password: string;
  repeatPassword: string;
}

export function RegisterPage() {
  const classes = useStyles();

  const [registerInfo, setRegisterInfo] = useState<RegisterInfo>({
    username: "",
    password: "",
    repeatPassword: "",
  });

  const handleChangeRegisterInfo = useCallback((partialRegisterInfo: Partial<RegisterInfo>) => {
    setRegisterInfo((registerInfo: RegisterInfo) => ({
      ...registerInfo,
      ...partialRegisterInfo,
    }));
  }, []);

  return (
    <form onSubmit={() => registerInfo}>
      <TextField
        label="E-mail адрес"
        variant="outlined"
        size="small"
        disabled
        margin={"normal"}
        onChange={handleChangeUsername}
        fullWidth
      />
      <TextField
        label="Пароль"
        variant="outlined"
        type="tel"
        size="small"
        disabled
        margin={"normal"}
        onChange={handleChangePassword}
        fullWidth
      />
      <TextField
        label="Повторить пароль"
        variant="outlined"
        type="password"
        size="small"
        disabled
        margin={"normal"}
        onChange={handleChangeRepeatPassword}
        fullWidth
      />
      <Button
        className={classes.submit}
        variant="contained"
        disabled
        type="submit"
        color="primary"
        size={"medium"}
        fullWidth
      >
        Регистрация
      </Button>
    </form>
  );

  function handleChangeUsername(e: ChangeEvent<HTMLInputElement>) {
    handleChangeRegisterInfo({ username: e.target.value });
  }

  function handleChangePassword(e: ChangeEvent<HTMLInputElement>) {
    handleChangeRegisterInfo({ password: e.target.value });
  }

  function handleChangeRepeatPassword(e: ChangeEvent<HTMLInputElement>) {
    handleChangeRegisterInfo({ repeatPassword: e.target.value });
  }
}
